import React from 'react'

export default function ButtonPost( props ) {
    const { buttonHandler } = props 
    return (
        <div className="ml-3 mt-4">
            <button 
                type="button" 
                id="publish-button" 
                class="btn-publish-post p-2 rounded text-white"
                onClick={ buttonHandler }
            >Publish</button>
            <button 
                type="button" 
                class="btn-save-draft rounded p-2 ml-3"
            >Save draft</button>
            <svg width="24" class="crayons-icon" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby="75abcb76478519ca4eb9">
                <title id="75abcb76478519ca4eb9">Post options</title>
                <path d="M12 1l9.5 5.5v11L12 23l-9.5-5.5v-11L12 1zm0 2.311L4.5 7.653v8.694l7.5 4.342 7.5-4.342V7.653L12 3.311zM12 16a4 4 0 110-8 4 4 0 010 8zm0-2a2 2 0 100-4 2 2 0 000 4z"></path>
            </svg>
        </div>
    )
}
